export const numberFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "CAD",
});